import React, { useEffect, useState } from "react";
import { XMarkIcon } from "@heroicons/react/20/solid"; 
import { Text } from "../tailwind/text";

const SidePanel = ({ isSidePanelOpen, onClose, children, title }) => {
  const [isAnimating, setIsAnimating] = useState(true);

  return (
    <>
      {(isSidePanelOpen || isAnimating) && (
         <aside
         className={`fixed w-96 top-1/2 right-1/2 transform -translate-y-1/2 bg-white overflow-hidden rounded-customBorderRadius max-h-[99vh] scroll-color shadow-lg z-[-10] transition-all duration-500 ease-out ${
           isSidePanelOpen
             ? "-translate-x-[63%] opacity-100 "
             : "translate-x-full opacity-0 "
         }`}
       >
          <button
            onClick={onClose}
            className="absolute top-2 right-2 p-1 rounded hover:bg-gray-200 dark:hover:bg-gray-700 hover:cursor-pointer z-50"
          >
            <XMarkIcon
              className="w-4 h-4 text-gray-600 dark:text-gray-400"
              aria-hidden="true"
            />
          </button>
          <Text className="p-3 font-bold">{title}</Text>

          <div className="px-3 pb-3 min-h-[300px] max-h-[91vh] h-full overflow-y-auto thin-scrollbar flex flex-col justify-between">{children}</div>
        </aside>
      )}
    </>
  );
};

export default SidePanel;
